<template>
  <el-dialog title="Bater Ponto" :visible.sync="abrirDialog.aberto" @close="fecharDialog" class="dialog">
    <span>
      <el-form :model="ponto" status-icon :ref="ponto" :rules="regras" label-width="51px">
        <el-form-item label="Data" prop="data">
          <el-date-picker v-mask="'##/##/####'" v-model="ponto.data" type="date" placeholder="Escolha a data"
            value-format="dd/MM/yyyy" format="dd/MM/yyyy">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="Hora" prop="hora">
          <el-time-picker v-mask="'##:##'" v-model="ponto.hora" placeholder="Escolha o horário"
            value-format="HH:mm" format="HH:mm">
          </el-time-picker>
        </el-form-item>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button class="botao-cancelar" @click="fecharDialog">Cancelar</el-button>
      <el-button class="botao" @click="baterPonto()" :loading="carregando">Bater Ponto</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    abrirDialog: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    carregando: false,
    ponto: {
      data: '',
      hora: ''
    },
    dateTime: '',
    regras: {
      data: [
        { required: true, message: 'O campo data é obrigatório' }
      ],
      hora: [
        { required: true, message: 'O campo hora é obrigatório' }
      ]
    }
  }),
  async created() {
    this.getDateTime();
  },
  methods: {
    getServerTime() {
      return new Promise(resolve => {
        this.$db.ref('.info/serverTimeOffset').once('value', snap => {
          const offset = snap.val();
          const dataserver = new Date().getTime() + offset;
          resolve(moment(dataserver));
        });
      });
    },
    async getDateTime() {
      const dateTime = await this.getServerTime();
      this.ponto.data = dateTime.format('DD/MM/YYYY');
      this.ponto.hora = dateTime.format('HH:mm');
    },
    salvaNovoHorario(data, element) {
      return new Promise(resolve => {
        data.push(element, () => resolve(true));
      });
    },
    deletaHorarios(data) {
      return new Promise(resolve => {
        data.remove(() => resolve(true));
      });
    },
    ordenaHoras(data) {
      data.once('value', async snap => {
        const horarios = Object.values(snap.val());
        await this.deletaHorarios(data);
        horarios.sort((a, b) => {
          if (a.data > b.data) return 1;
          return 0;
        });
        horarios.filter(h => h.tipo !== 'justificativa').forEach(async (element, index) => {
          element.tipo = index % 2 === 0 ? 'entrando' : 'saindo';
          await this.salvaNovoHorario(data, element);
        });
        horarios.filter(h => h.tipo === 'justificativa').forEach(async element => {
          await this.salvaNovoHorario(data, element);
        });
        this.$message.success('Ponto batido com sucesso.');
        this.carregando = false;
        this.abrirDialog.aberto = false;
      });
    },
    getTipoPonto(date_time) {
      return new Promise(resolve => {
        const db = this.$db.ref(`horarios/${this.$route.params.user}/${date_time.format('YYYY')}/${date_time.format('MM')}/${date_time.format('DD')}`);
        db.once('value', snap => {
          const tamanho = (Object.entries(snap.val() || []).filter(val => val.tipo !== 'justificativa').length);
          resolve(tamanho % 2);
        });
      });
    },
    getColaborador() {
      return new Promise(resolve => {
        const colaborador = this.$db.ref(`colaboradores/${this.$route.params.user}`);
        colaborador.once('value', colab => {
          resolve(`${colab.val().nome} ${colab.val().sobrenome}`);
        });
      });
    },
    async baterPonto() {
      this.carregando = true;
      const date_time = moment(`${this.ponto.data} ${this.ponto.hora}:00`, 'DD/MM/YYYY HH:mm:ss');
      const tipo = await this.getTipoPonto(date_time);
      const data = this.$db.ref(`horarios/${this.$route.params.user}/${date_time.format('YYYY')}/${date_time.format('MM')}/${date_time.format('DD')}`);
      const nome_colaborador = await this.getColaborador();

      data.push({
        data: date_time.format('YYYY-MM-DD HH:mm:ss'),
        tipo: (tipo) ? 'saindo' : 'entrando', // Se par, está entrando. Se ímpar está saindo
        colaborador: nome_colaborador
      }, error => {
        if (error) this.$message.error(`${error.code} ${error.message}`);
        this.ordenaHoras(data, nome_colaborador);
      });
    },
    fecharDialog() {
      this.$refs[this.ponto].resetFields();
      this.abrirDialog.aberto = false;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.el-date-editor {
  width: 100%;
}
</style>
